import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Container, Card, Button, Table } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

const QRCodeConfirmation = () => {
  const location = useLocation();
  const appointment = location.state?.appointment;

  if (!appointment) {
    return (
      <Container className="text-center py-5" style={{ marginTop: '100px' }}>
        <div className="alert alert-warning py-4 rounded-4 shadow-sm">
          <h4>Aucune confirmation de réservation disponible.</h4>
          <p className="text-muted mb-4">Veuillez réserver un service depuis l'accueil.</p>
          <Link to="/">
            <Button variant="primary" className="rounded-pill px-4">Retourner à l'accueil</Button>
          </Link>
        </div>
      </Container>
    );
  }

  // QR Code Payload encoding
  const qrData = encodeURIComponent(
    `Bookly ID: ${appointment._id}\nClient: ${appointment.clientName}\nEmail: ${appointment.clientEmail}\nDate: ${format(parseISO(appointment.date), 'dd/MM/yyyy')}\nHeure: ${appointment.startTime}\nTotal: ${appointment.totalPrice} DT`
  );
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${qrData}`;

  return (
    <Container className="d-flex justify-content-center align-items-center py-5" style={{ marginTop: '90px' }}>
      <Card className="shadow-lg border-0 rounded-4 overflow-hidden text-center" style={{ maxWidth: '520px', width: '100%' }}>
        <div style={{ height: '6px', background: 'linear-gradient(90deg, #13223c, #c69d4e)' }}></div>
        <Card.Body className="p-5">
          <div className="display-4 text-success mb-3">✓</div>
          <Card.Title as="h2" className="font-weight-bold text-dark mb-1">
            Réservation Confirmée !
          </Card.Title>
          <Card.Text className="text-muted mb-4">
            Présentez ce QR Code lors de votre arrivée à l'établissement.
          </Card.Text>

          {/* QR Code display */}
          <div className="p-3 bg-light rounded-4 d-inline-block border mb-4">
            <img src={qrCodeUrl} alt="Booking QR Code" style={{ width: '220px', height: '220px', objectFit: 'contain' }} />
          </div>

          <h5 className="font-weight-bold text-secondary mb-3">Détails de la réservation</h5>
          <Table bordered hover striped size="sm" className="text-start mb-4" style={{ fontSize: '14.5px' }}>
            <tbody>
              <tr>
                <td className="text-muted font-weight-bold" style={{ width: '140px' }}>Référence ID</td>
                <td><code style={{ fontSize: '13px' }}>{appointment._id}</code></td>
              </tr>
              <tr>
                <td className="text-muted font-weight-bold">Établissement</td>
                <td><strong>{appointment.provider?.businessName || "Bookly Services"}</strong></td>
              </tr>
              <tr>
                <td className="text-muted font-weight-bold">Service(s)</td>
                <td>
                  {appointment.services && appointment.services.length > 0 ? (
                    <ul className="list-unstyled mb-0 font-weight-bold">
                      {appointment.services.map((s, idx) => (
                        <li key={idx}>• {s.name}</li>
                      ))}
                    </ul>
                  ) : (
                    <strong>{appointment.service?.name || "Prestation standard"}</strong>
                  )}
                </td>
              </tr>
              <tr>
                <td className="text-muted font-weight-bold">Date & Heure</td>
                <td>{format(parseISO(appointment.date), 'dd/MM/yyyy')} à <strong>{appointment.startTime}</strong></td>
              </tr>
              <tr>
                <td className="text-muted font-weight-bold">Total réglé</td>
                <td className="text-success font-weight-bold">{appointment.totalPrice} DT</td>
              </tr>
            </tbody>
          </Table>

          <div className="d-flex gap-3 justify-content-center">
            <Button variant="outline-primary" className="rounded-pill px-4" onClick={() => window.print()}>
              Imprimer 🖨️
            </Button>
            <Link to="/">
              <Button variant="primary" className="rounded-pill px-4">
                Accueil
              </Button>
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default QRCodeConfirmation;
